import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { Smartphone, X, Apple } from "lucide-react";

const PWAInstallBanner = () => {
  const { lang } = useApp();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("hf_pwa_dismissed") === "1") return;
    if (window.matchMedia("(display-mode: standalone)").matches) { setInstalled(true); return; }

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // For iOS Safari (no beforeinstallprompt support), show iOS install instructions
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
      setTimeout(() => setShow(true), 4000);
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") {
      setInstalled(true);
      setShow(false);
    }
  };

  const dismiss = () => {
    localStorage.setItem("hf_pwa_dismissed", "1");
    setShow(false);
  };

  if (installed || !show) return null;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-40 bg-white rounded-2xl shadow-card border border-border/60 p-4 flex items-start gap-3 animate-fade-up" data-testid="pwa-install-banner">
      <div className="w-12 h-12 rounded-xl bg-holy-red/10 flex items-center justify-center shrink-0">
        {isIOS ? <Apple className="w-6 h-6 text-holy-red" /> : <Smartphone className="w-6 h-6 text-holy-red" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-serif text-base text-foreground">
          {lang === "id" ? "Install Holy Flowy App" : "Install Holy Flowy App"}
        </div>
        <div className="text-xs text-muted-foreground mt-0.5">
          {isIOS
            ? (lang === "id" ? "Tap ikon Share → 'Add to Home Screen'" : "Tap Share icon → 'Add to Home Screen'")
            : (lang === "id" ? "Pasang di home screen HP Anda — akses 1 klik!" : "Add to your home screen for 1-click access!")}
        </div>
        {!isIOS && deferred && (
          <button onClick={install} data-testid="pwa-install-btn" className="mt-2 bg-holy-red text-ivory rounded-full px-4 py-1.5 text-xs font-medium hover:-translate-y-0.5 transition-all">
            {lang === "id" ? "Install Sekarang" : "Install Now"}
          </button>
        )}
      </div>
      <button onClick={dismiss} data-testid="pwa-dismiss" className="p-1 hover:bg-cream rounded-full" aria-label="Dismiss">
        <X className="w-4 h-4 text-muted-foreground" />
      </button>
    </div>
  );
};

export default PWAInstallBanner;
